import React from 'react'
import TreeSelect from 'components/TreeSelect'

const LocationFilter = ({ state, handleLocationChange, checkLocation ,locationFilter}) => {
  return (
    <TreeSelect
          showArrow={true}
          filterTreeNode={false}
          treeCheckable={true}
          placeholder="Select Location"
          maxTagCount={0}
          showSearch={true}
          treeDefaultExpandAll={true}
          removeTreeIndent={true}
          shadowBox
          onChange={handleLocationChange}
          treeData={locationFilter || []}
          value={checkLocation || []}
          height={'auto'}
          treeNodeFilterProp="title"
          autoClearSearchValue={false}
        />
  )
}

export default LocationFilter
